export default __webpack_public_path__ + "static/media/00.5531dcad.jpg";